<template>
	<div>
		<div class="nav">
			<router-link :to="`/${group}`" exact
				><span class="all">all</span></router-link
			>
			<router-link
				v-for="link of itemListKeys"
				:to="`/${group}/${link}`"
				:key="link"
			>
				<span :class="link">{{ link }}</span>
			</router-link>
		</div>
		<filters
			:filters-available="filtersAvailable"
			:filters="filters"
			@toggle-filter="toggleFilter($event)"
		/>
		<item-section
			v-for="itemType in itemListKeys"
			:key="itemType"
			:item-type="itemType"
			:items="itemList(itemType, group)"
			:visible="
				!$route.params.hasOwnProperty('itemType') ||
				$route.params.itemType === itemType
			"
			@click-item="toggleItem($event)"
		></item-section>
	</div>
</template>

<script>
import ItemSection from '@/components/item-section';
import Filters from '@/components/filters';
import { mapActions, mapGetters } from 'vuex';

export default {
	props: ['itemListKeys', 'group'],
	components: { Filters, ItemSection },
	computed: mapGetters(['filters', 'filtersAvailable', 'itemList']),
	methods: mapActions(['toggleFilter', 'toggleItem']),
};
</script>

<style lang="scss">
.nav {
	a span::before {
		background-size: 50px;
	}
	.all::before {
		background-image: url(../assets/img/all.svg);
		background-size: 44px;
	}
	.bug::before {
		background-image: url(../assets/img/bug.svg);
		background-size: 56px;
	}
	.fish::before {
		background-image: url(../assets/img/fish.svg);
		background-size: 50px;
	}
	.sea::before {
		background-image: url(../assets/img/sea.svg);
		background-size: 40px;
	}
	.art::before {
		background-image: url(../assets/img/art.svg);
		background-size: 36px;
	}
	.tops::before {
		background-image: url(../assets/img/tshirt.svg);
	}
	.bottoms::before {
		background-image: url(../assets/img/shorts.svg);
	}
	.dresses::before {
		background-image: url(../assets/img/dress.svg);
	}
	.headwear::before {
		background-image: url(../assets/img/hat.svg);
	}
	.accessories::before {
		background-image: url(../assets/img/glasses.svg);
	}
	.socks::before {
		background-image: url(../assets/img/socks.svg);
	}
	.shoes::before {
		background-image: url(../assets/img/shoes.svg);
	}
	.bags::before {
		background-image: url(../assets/img/bag.svg);
	}
	.umbrellas::before {
		background-image: url(../assets/img/umbrella.svg);
	}
	.music::before {
		background-size: 40px;
		background-image: url(../assets/img/music.svg);
	}
	.recipe::before {
		background-size: 36px;
		background-image: url(../assets/img/recipe.svg);
	}
}
</style>
